(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener(
    'click',
    function (e) {
      const loadMoreBtn = e.target.closest('.load-more-pagination__button');
      if (!loadMoreBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (loadMoreBtn.classList.contains('is-loading')) return;
      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.textContent = 'CARREGANDO...';

      let nextUrl = loadMoreBtn.getAttribute('href');
      if (!nextUrl) return;

      const currentSearchParams = window.location.search;
      if (currentSearchParams && !nextUrl.includes('sort_by') && currentSearchParams.includes('sort_by')) {
        const urlObj = new URL(nextUrl, window.location.origin);
        const currentParams = new URLSearchParams(currentSearchParams);
        currentParams.forEach((value, key) => {
          if (!urlObj.searchParams.has(key)) {
            urlObj.searchParams.set(key, value);
          }
        });
        nextUrl = urlObj.toString();
      }

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newItems = doc.querySelectorAll('.product-list__item');
          const currentGrid = document.querySelector('#product-grid') || document.querySelector('product-list');

          if (currentGrid && newItems.length > 0) {
            const fragment = document.createDocumentFragment();
            newItems.forEach((item) => fragment.appendChild(item));
            currentGrid.appendChild(fragment);
          }

          const newPagination = doc.querySelector('.load-more-pagination');
          const currentPagination = document.querySelector('.load-more-pagination');

          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          } else if (currentPagination) {
            currentPagination.remove();
          }
        })
        .catch((error) => {
          console.error('Erro ao carregar mais produtos:', error);
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.textContent = 'VER MAIS';
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
